<div
  class="modal-header bg-head py-2 d-flex justify-content-between align-items-center"
>
  <h6 class="modal-title mb-0">Relocate Topic</h6>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onCross()"
  ></button>
</div>
<div class="modal-body m-body pt-0">
  <app-subject-relocate
   [MajorTopic]="MajorTopic"
   [Refresh]="Refresh"
   [SubjectParentInput]="SubjectParentInput"
   [FromWhichComponent]="'Edit Study Unit'"
   [StudyUnit]="this.StudyUnit"
   (closeAddEditElement)="closeAddEditElement($event)"
   (cancelSubjectParentChange)="onCancel($event)"

  ></app-subject-relocate>
</div>
